<!-- 落地页管理-新增 -->
<template>
<div style="">
	<!-- 标题 -->
	<!-- 头条/广点通/OPPO/VIVO/百度 -->
	<div class="page-title" style="margin-left: 30px;">{{page_title}}快应用落地页</div>
	
	<div style="width: 80vw;margin:  30px auto 30px;">
		
		<div class="form-cell-box">
			<div class="class-title">名称<span class="required-hint">*</span></div>
				
			<a-input v-model="r_title" placeholder="请输入" :style="{'width': widths + 'px'}"  />
		</div>
		
		<div class="form-cell-box">
			<div class="class-title">渠道<span class="required-hint">*</span></div>
			<a-select
				show-search
				:style="{'width': widths + 'px'}"
				placeholder="请选择"
				@change="addChangeA"
				:filter-option="filterOption"
				:getPopupContainer="getsPopupContainer"
				:value="r_qk_platform"
			  >
				<a-select-option value="99">
				  常读快应用
				</a-select-option>
				<a-select-option value="100">
				  文鼎快应用
				</a-select-option>
				<a-select-option value="103">
				  乐读快应用
				</a-select-option>
			</a-select>
		</div>
		
		<div class="form-cell-box">
			<div class="class-title">快应用推广链接<span class="required-hint">*</span></div>
			<!-- <a-select
				show-search
				:style="{'width': widths + 'px'}"
				placeholder="请选择"
				notFoundContent="请先选择: 渠道 ↑ 或 推广链接内容为空" 
				@change="addChangeB"
				:filter-option="filterOption"
				:getPopupContainer="getsPopupContainer"
				:value="r_link_id"
			  >
				<a-select-option v-for="(item,index) in tgSelectData" :key="index" :value="item.id">
				  {{item.name || '空'}}
				</a-select-option>
			</a-select> -->
			<a-select
				:style="{'width': widths + 'px'}"
				placeholder="请选择推广链接"
				notFoundContent="← 请先选择: 快应用平台 或 平台没有内容" 
				:filter-option="false"
				@change="handleChangeB"
				:getPopupContainer="getsPopupContainer" 
				@popupScroll="popupScrollCEshi" 
				showSearch
				allowClear
				@search="selectZhSearch"
				:not-found-content="s_fetching ? undefined : null" 
				@blur="zhBlur" 
				:value="r_link_id"
			  >
				<a-spin v-if="s_fetching" slot="notFoundContent" size="small" />
				<a-select-option v-for="(item,index) in tgSelectData" :key="item.id" :value="item.id">
				  {{item.name || '空'}}
				</a-select-option>
				<a-select-option v-if="loading_more_hint" value="-0-">
					<div style="color:rgb(98, 168, 234)">加载更多中...</div>
					
				</a-select-option>
			</a-select>
		</div>
		
		<div v-show="r_put_platform == '4'" class="form-cell-box">
			<div class="class-title">HAP链接</div>
			
			<div v-if="r_link_id" :style="{'width': widths + 'px'}">{{r_hap_url || '此快应用推广链接没有HAP链接。可到推广链接页面去设置'}}</div>
			<div v-else>请先选择快应用推广链接↑</div>
			<!-- <a-input v-model="r_hap_url" placeholder="hap://开头的链接" :style="{'width': widths + 'px'}"  /> -->
		</div>
		
		<!-- 新增头条/广点通/OPPO/VIVO落地页 开始 -->
		<div class="form-cell-box">
			<div class="class-title">投放平台</div>
			<a-select
				show-search
				:style="{'width': widths + 'px'}"
				placeholder="请选择"
				@change="addChangeTA"
				:value="r_put_platform"
				:filter-option="filterOption"
				:getPopupContainer="getsPopupContainer"
				:disabled="put_disabled"
			  >
				<a-select-option  value="4">
				  华为
				</a-select-option>
				<!-- <a-select-option  value="toutiao">
				  头条
				</a-select-option>
				<a-select-option  value="gdt">
				  广点通
				</a-select-option>
				<a-select-option  value="oppo">
				  OPPO
				</a-select-option>
				<a-select-option  value="vivo">
				  VIVO
				</a-select-option>
				<a-select-option  value="baidu">
				  百度
				</a-select-option> -->
			</a-select>
		</div>
		
		<div v-show="r_put_platform == 'toutiao'" class="form-cell-box">
			<div class="class-title">头条付费回传方式<span class="required-hint">*</span></div>
			<a-select
				show-search
				:style="{'width': widths + 'px'}"
				placeholder="请选择"
				@change="addChangeG"
				:value="r_tt_report_type" 
				:filter-option="filterOption"
				:getPopupContainer="getsPopupContainer"
			  >
				<a-select-option  value="2">
				  事件管理
				</a-select-option>
				<a-select-option  value="1">
				  转化跟踪
				</a-select-option>
			</a-select>
		</div>
		
		<!-- OPPO-广告账户 -->
		<!-- <div v-show="r_put_platform == 'oppo'" class="form-cell-box">
			<div class="class-title">(OPPO)广告账户<span class="required-hint">*</span></div>
			<a-select
				show-search
				:style="{'width': widths + 'px'}"
				placeholder="请选择"
				@change="addChangeH"
				:value="r_media_account_id"
				:filter-option="filterOption"
				:getPopupContainer="getsPopupContainer"
			  >
				<a-select-option v-for="(value,key) in OPPOggList" :value="key">
				  {{value}}
				</a-select-option>
			</a-select>
		</div> -->
		<div v-show="r_put_platform == 'oppo'" class="form-cell-box">
			<div class="class-title">微信复制回传转化ID(JS跟踪)</div>
				
			<a-input v-model="r_convert_id" placeholder="请输入" :style="{'width': widths + 'px'}"  />
		</div>
		
		<!-- VIVO广告账户 -->
		<!-- <div v-show="r_put_platform == 'vivo'" class="form-cell-box">
			<div class="class-title">(VIVO)广告账户<span class="required-hint">*</span></div>
			<a-select
				show-search
				:style="{'width': widths + 'px'}"
				placeholder="请选择"
				@change="addChangeI"
				:value="r_media_account_id"
				:filter-option="filterOption"
				:getPopupContainer="getsPopupContainer"
			  >
				<a-select-option  v-for="(value,key) in VIVOggList" :value="key">
				  {{value}}
				</a-select-option>
			</a-select>
		</div> -->
		
		<!-- 百度部分开始 -->
		<div v-show="r_put_platform == 'baidu'" class="form-cell-box">
			<div class="class-title">回传方式</div>
			<a-select
				show-search
				:style="{'width': widths + 'px'}"
				placeholder="请选择"
				@change="bdChangeA"
				:filter-option="filterOption"
				:getPopupContainer="getsPopupContainer"
				:value="r_bd_report_type"
			  >
				<a-select-option  value="0">
				  一句话咨询
				</a-select-option>
				<a-select-option  value="1">
				  营销通+付费阅读
				</a-select-option>
			</a-select>
		</div>
		
		<div v-show="r_put_platform == 'baidu' && r_bd_report_type == '1'" class="form-cell-box" >
			<div class="class-title">是否回传加粉</div>
				
			<a-switch :checked="r_open_put"  @change="bdChangeC" checked-children="打开" un-checked-children="关闭" />
		</div>
		
		<div v-show="r_put_platform == 'baidu' && r_bd_report_type == '0'" class="form-cell-box" >
			<div class="class-title">回传Token</div>
			
			<div>
				<div v-for="(item,index) in r_hc_token" :key="index" style="display: flex;align-items: center;margin-bottom: 10px;">
					<a-input v-model="item.value" style="display: block;" placeholder="获取方式：百度后台，转化跟踪详情" :style="{'width': widths + 'px'}"  />
					<div @click="delHcToken(item,index)" style="color: red;margin-left: 15px;cursor: pointer;">删除</div>
				</div>
			</div>
			
		</div>
		<div v-show="r_put_platform == 'baidu' && r_bd_report_type == '0'" class="form-cell-box" style="margin-top: -15px;">
			<div class="class-title"></div>
				
			<a-button @click="addHcToken" size="small" type="primary">
			    新增回传Token
			</a-button>
		</div>
		
		<div v-show="r_put_platform == 'baidu' && r_bd_report_type == '1'" class="form-cell-box">
			<div class="class-title">新链路回传书城<span class="required-hint">*</span></div>
			<a-select
				show-search
				:style="{'width': widths + 'px'}"
				placeholder="请选择"
				@change="bdChangeB"
				:filter-option="filterOption"
				:getPopupContainer="getsPopupContainer"
				defaultValue="1"
			  >
				<a-select-option value="1">
				  乐读小说
				</a-select-option>
			</a-select>
		</div>
		<!-- 百度部分结束 -->
		<!-- 新增头条/广点通/OPPO/VIVO落地页 结束 -->
		
		<!-- 页面元素设置 -->
		<div class="form-cell-box">
			<div class="class-title" style="font-size: 18px;font-weight: bold;">页面元素设置</div>
			
		</div>
		
		<div class="form-cell-box">
			<div class="class-title">域名地址<span class="required-hint">*</span></div>
			<a-select
				show-search
				:style="{'width': widths + 'px'}"
				placeholder="请选择"
				@change="addChangeF"
				:filter-option="filterOption"
				:getPopupContainer="getsPopupContainer"
				:value="r_put_url"
			  >
				<a-select-option v-for="(value,key) in domainList" :key="key" :value="key">
				  {{value}}
				</a-select-option>
			</a-select>
		</div>
		
		<!-- 头条部分 -->
		<div class="form-cell-box">
			<div class="class-title">落地页类型<span class="required-hint">*</span></div>
			<a-select
				show-search
				:style="{'width': widths + 'px'}"
				placeholder="请选择"
				@change="addChangeTB"
				:filter-option="filterOption"
				:getPopupContainer="getsPopupContainer"
				:value="r_jump_content_type"
			  >
				<!-- <a-select-option v-if="r_put_platform == 'toutiao' || r_put_platform == 'oppo' || r_put_platform == 'vivo'" value="2">
				  有内容落地页
				</a-select-option> -->
				<a-select-option v-if="r_put_platform == '4' || r_put_platform == 'toutiao' || r_put_platform == 'gdt' || r_put_platform == 'baidu'" value="1">
				  跳转页
				</a-select-option>
			</a-select>
		</div>
		
		
		
		
		<div style="color: red;height: 23px;width: 100%;">{{add_form_hint}}</div>
		
		<div class="form-cell-box" style="margin-top: 30px;padding-left: 130px;">
			<a-button @click="addRequest" :loading="add_button_loading" type="primary" style="margin-right: 20px;">确认</a-button>
			<a-button @click="addCloseDrawer">返回</a-button>
		</div>
	</div>
	
	<!-- 加载中 -->
	<div class="loading-box" v-show="search_button_loading">
		<a-spin size="large" />
	</div>
</div>
</template>

<script>
function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
}
import { landQASelect, landPagePlatform,landPageJumpType, landPageChannelGzh, 
getPutDomain,landPageSixMedia, landOppoList, landVivoList, 
landGzhXcx, landAddUploadImage, landAddButton, landQaInfo, landEditButton, landQaAdd, landQaEdit } from '@/request/api'
import Editors from '@/components/Editors.vue'
export default {
	name: 'landQuickAppAdd_',
	components: {
		Editors
	},
	data() {
		return {
			// 筛选条件部分
			filterData: {
				op_id:{ // 投手
					list: [{}],
				},
				channel_id:{ // 书城渠道
					list: [{}],
				},
				gzh_id:{ // 公众号
					list: [{}],
				},
				
			}, // 筛选条件数组
			PlatformData: {}, // 落地页推广平台数据
			JumpTypeData: {}, // 落地页跳转方式数据
			
			
			
			widths: 630, // 内容的宽度
			// 新增侧边栏
			add_visible: false, 
			aaa:"",
			add_type: "0", // 新增类型。0为新增头条/广点通/OPPO/VIVO落地页。1为新增百度跳转页。2为新增360落地页
			add_drawer_title: "新增360落地页",
			add_form_hint: "", // 新增侧边栏的提示
			add_button_loading: false,
			gzhSelectList: {},
			mediaSelectList: {},
			sixMubanList: {},
			domainList: {},
			
			// 头条部分
			
			sync_true: false, // 刷新的icon是否旋转
			ghzXcxObj: [{}], // 公众号绑定的小程序
			ghzXcx_url: "未设置，请设置后刷新。设置方式：前往授权公众号管理页面", // 公众号关注页链接
			ghzXcx_control: false, // 跳转设置控制
			ghzXcx_id: "", // 请求用的id
			// 企微客服
			ghzKfObj: [{}], // 跳转企业微信客服
			ghzKf_control: false, // 企业微信客服跳转设置控制
			
			OPPOggList: [], // oppo下拉列表
			VIVOggList: [], // VIVO下拉列表
			headers_token: "", // 图片上传用的token
			loading: false,
			imageUrl: '',
			
			r_title: "", // 落地页名称
			r_put_platform: "4", // 投放平台。4表示华为。根据不同的投放平台控制页面显示不同的填写内容
			
			r_gzh_id: undefined, // 公众号id
			
			r_convert_id: "", // 微信复制回传转化ID(JS跟踪)。非必填
			r_media_account_id: "", // 广告账户。投放平台vivo或者oppo必填项media_account_id媒体账号Id
			r_tt_report_type: "2", // 头条付费回传方式。上报类型，投放平台头条：默认值0和1转化跟踪，2代表事件
			
			r_background_color: "#FFFFFF", // 背景色
			
			r_put_url: undefined, // 投放域名id
			r_jump_content_type: "1", // 落地页类型。跳转内容方式2：内容页，1=跳转页
			
			r_company_name: "", // 审核公司。投放平台不为百度必填项company_name审核公司
			r_jump_type: undefined, // 跳转方式。跳转地址
			
			r_top_image: "", // 头部图片
			r_put_content: "", // 富文本-投放内容
			r_verify_content: "", // 富文本-审核内容
			r_open_put: false, // 投放开关。是否打开投放  0=否，1=是
			
			r_report_per: 100, // 回传比例
			r_report_money_limit: window.$InitialValues.report_money_limit, // 回传最低金额
			r_report_hour_limit: 24, // 回传小时限制
			r_report_only_cur_day: true, // 只回传当天 0=否，1=是
			r_report_only_once: true, // 只回传一次 0=否，1=是
			r_is_supply_active_pay: true, // 巨量付费2回传。1打开，0是关闭
			r_memo: "", // 备注/投放平台百度必填项memo回传Token
			
			// 百度
			r_bd_report_type: "0", // 回传方式
			r_hc_token: [ // 回传Token
				{value:""}
			],
			
			search_button_loading: false,
			
			// 编辑
			put_disabled: false, // 投放平台是否禁用
			page_title: "新增", // 页面标题
			
			
			// 快应用落地页搜索条件下拉
			qaSelectData: {},
			tgSelectData: [], // 快应用推广链接id
			
			r_edit_id: null, // 传过来的用于编辑的列表id
			r_qk_platform: undefined, // 快应用平台/渠道
			r_link_id: undefined, // 快应用推广链接id
			r_hap_url:"", // HAP链接
			
			// 快应用推广链接下拉框
			s_page: 1,
			s_limit: 100,
			s_adv_name: "", // 下拉选择框的搜索字段
			s_fetching: false, // 用于控制提示
			tgSelectData: [], // 快应用推广链接
			blurTgData: [], // 保存一份，用于失去焦点后，回复原来的数值
			loading_more_control: true, // 上拉加载更多控制
			loading_more_hint: false, // 上拉加载更多的提示
		}
	},
	mounted() {
		let that = this
		
		that.search_button_loading = true
		
		that.widths = Math.floor(document.body.clientWidth*0.8 - 210)
		console.log("that.widths",that.widths);
		
		// 图片上传用的token
		this.headers_token = 'Bearer ' + localStorage.getItem("access_token")
		
		
		// 获取转换域名
		getPutDomain().then(res=>{
			console.log("获取转换域名",res.data);
			that.domainList = res.data.data.data
		})
		
		landPagePlatform().then(res=>{
			console.log("落地页推广平台",res.data.data);
			that.PlatformData = res.data.data.list
		}) 
		
		landPageJumpType().then(res=>{
			console.log("落地页跳转方式",res.data.data);
			that.JumpTypeData = res.data.data.list
		})
		
		// oppo下拉列表
		// landOppoList().then(res=>{
		// 	console.log("oppo下拉列表",res);
		// 	that.OPPOggList = res.data.data.list
		// })
		
		// VIVO下拉列表
		// landVivoList().then(res=>{
		// 	console.log("vivo下拉列表",res);
		// 	that.VIVOggList = res.data.data.list
		// })
		
		landQASelect().then(res=>{
			console.log("快应用下拉联动",res);
			that.qaSelectData = res.data.data
		})
		
		console.log(this.$route.query)
		if(that.$route.query){
			// 接收从小程序跳转码页面传过来的参数、小程序跳转码每日使用量页
			if(that.$route.query.link_id){
				that.r_edit_id = that.$route.query.link_id
				that.put_disabled = true // 平台选择禁用
				that.page_title = "编辑"
				// 获取编辑的内容
				landQaInfo({
					id: that.r_edit_id
				}).then(res=>{
					console.log("获取编辑的内容",res.data.data.info);
					
					let editObject = res.data.data.info
					that.r_title = editObject.title // 名称
					that.r_qk_platform = editObject.qk_platform.toString() // 渠道id
					
					that.addChangeA(editObject.qk_platform.toString(),editObject.link.name || null) // 获取公众号选择器内容
					that.addChangeB(Number(editObject.link_id)) // 获取快应用推广链接相关内容
					
					that.r_put_platform = editObject.put_platform.toString() // 投放平台
					
					that.r_put_url = editObject.put_domain.toString() // 投放域名地址
					
					// 落地页类型。跳转内容方式1：内容页，2=跳转页
					if(editObject.put_platform != "baidu"){
						that.r_jump_content_type = editObject.jump_type.toString()
					}
					
					
					setTimeout(()=>{
						that.search_button_loading = false
					},300)
				})
			}
			else {
				setTimeout(()=>{
					that.search_button_loading = false
				},500)
			}
			
		}
		else {
			setTimeout(()=>{
				that.search_button_loading = false
			},500)
		}
	},
	methods: {
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		filterOption(input, option) {
		    return (
		        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		    );
		},
		
		// 快应用推广链接id下拉框选择-开始
		handleChangeB(e){ // 快应用平台推广链接id
			// console.log(e);
			this.r_link_id = e
		},
		popupScrollCEshi(e){ // 上拉触底加载更多
			if(e.target.scrollHeight - e.target.scrollTop < 300){ // 上拉触底加载更多
				if(this.loading_more_control){ // 节流，保证这期间只执行一次
					this.loading_more_hint = true
					this.loading_more_control = false
					let that = this
					that.s_page = that.s_page + 1
					console.log("上拉触底加载更多");
					landQASelect({
						page: that.s_page,
						limit: that.s_limit,
						name: that.s_adv_name,
						type: that.r_qk_platform,
					}).then(res=>{
						console.log('选择',res);
						
						let data = that.tgSelectData 
						that.loading_more_hint = false
						that.tgSelectData = data.concat(res.data.data.list) 
						that.s_fetching = false
						that.loading_more_control = true
					})
				}
				
				
			}
		},
		// 选择框搜索-选择广告账户
		selectZhSearch(e){
			console.log("选择框搜索",e);
			let that = this
			that.tgSelectData = []
			that.s_fetching = true
			that.s_adv_name = e
			
			landQASelect({
				page: 1,
				limit: that.s_limit,
				name: e,
				type: that.r_qk_platform,
			}).then(res=>{
				console.log('选择',res);
				that.s_page = 1
				that.tgSelectData = res.data.data.list
				that.s_fetching = false
			})
		},
		// 失去焦点
		zhBlur(e){
			let that = this
			console.log("失去焦点",e);
			that.s_page = 1
			that.s_adv_name = '' // 清空
			that.tgSelectData = that.blurTgData 
		},
		// 快应用推广链接id下拉框选择-结束
		
		// 新增部分开始------
		// 显示新增侧边栏
		addShowDrawer(){
			let that = this
			// 360媒体id下拉列表
			landPageSixMedia().then(res=>{
				console.log("360媒体id下拉列表",res.data);
				that.mediaSelectList = res.data.data.list
			})
			
			// 获取转换域名
			getPutDomain().then(res=>{
				console.log("获取转换域名",res.data);
				that.domainList = res.data.data.data
			})
			
			
			this.add_visible = true
		},
		// 选择新增类型
		addTypeChange(e){
			console.log(e);
			this.add_type = e
			if(e == "0"){
				this.add_drawer_title = "新增头条/广点通/OPPO/VIVO落地页"
			}
			else if(e == "1"){
				this.add_drawer_title = "新增百度跳转页"
			}
			else if(e == "2"){
				this.add_drawer_title = "新增360落地页"
			}
		},
		// 新增侧边栏-选择渠道
		addChangeA(e,tg_name){
			let that = this
			console.log(e);
			// that.r_gzh_id = undefined
			that.r_link_id = undefined
			that.r_hap_url = ""
			that.r_qk_platform = e
			that.search_button_loading = true
			// 快应用下拉联动
			landQASelect({
				type: e,
				page: that.s_page,
				limit: that.s_limit,
				name: tg_name || null
			}).then(res=>{
				that.search_button_loading = false
				console.log("快应用下拉联动",res.data.data);
				that.tgSelectData = res.data.data.list
				that.blurTgData = res.data.data.list
			})
		},
		// 选择快应用推广链接id
		addChangeB(e){
			let that = this
			console.log(e);
			// this.ghzXcx_id = e
			// this.r_gzh_id = e
			// this.ghzXcxSync()
			
			this.r_link_id = e
			this.tgSelectData.forEach(res=>{
				if(res.id == e){
					this.r_hap_url = res.hap_url
					// if(!res.hap_url){
					// 	this.$message.warning('HAP链接为空')
					// }
				}
			})
		},
		// 刷新
		ghzXcxSync(){
			let that = this
			that.sync_true = true
			landGzhXcx({
				id: that.ghzXcx_id,
				type: "1" // 默认type=0，根据运营公众号id获取绑定小程序，type=1，根据投放公众号id获取绑定小程序
			}).then(res=>{
				that.sync_true = false
				console.log("公众号绑定的小程序",res);
				that.ghzXcx_url = res.data.data.jump_url || "未设置，请设置后刷新。设置方式：前往授权公众号管理页面"
				// 小程序的数据
				if(res.data.data.list.length > 0){
					
					that.ghzXcxObj = res.data.data.list
					let kkk = Object.keys(res.data.data.list[0])
					if(kkk.length > 0){
						that.ghzXcx_control = true
					}
					else {
						that.ghzXcx_control = false
					}
					
					// that.ghzKfObj = res.data.data.kf_list
					// let fff = Object.keys(res.data.data.kf_list[0])
					// if(fff.length > 0){
					// 	that.ghzKf_control = true
					// }
					// else {
					// 	that.ghzKf_control = false
					// }
				}
				else {
					that.ghzXcxObj = [{}]
					that.ghzXcx_control = false
				}
				
				// 企业微信客服的数据
				if(res.data.data.kf_list.length > 0){
					that.ghzKfObj = res.data.data.kf_list
					let fff = Object.keys(res.data.data.kf_list[0])
					if(fff.length > 0){
						that.ghzKf_control = true
					}
					else {
						that.ghzKf_control = false
					}
				}
				else {
					that.ghzKfObj = [{}]
					that.ghzKf_control = false
				}
			})
		},
		// 新增侧边栏-跳转方式
		addChangeC(e){
			
		},
		// 头条付费回传方式
		addChangeG(e){
			console.log(e)
			this.r_tt_report_type = e
		},
		//  OPPO-广告账户
		addChangeH(e){
			console.log(e)
			this.r_media_account_id = e
		},
		//  VIVO广告账户 
		addChangeI(e){
			console.log(e)
			this.r_media_account_id = e
		},
		
		
		// 新增侧边栏-投放域名地址
		addChangeF(e){
			this.r_put_url = e
		},
		
		// 新增头条/广点通/OPPO/VIVO
		addChangeTA(e){ // 投放平台
			console.log(e);
			
			// 选择不同的投放平台要对落地页类型进行状态重置
			if(e == 'toutiao' || e == 'oppo' || e == 'vivo'){
				this.r_jump_content_type = "1" // 显示有内容落地页
			}
			else if(e == 'gdt' || e == 'baidu'){
				this.r_jump_content_type = "2"
			}
			
			// 由于r_open_put被 投放开关 和 百度里的 是否回传加粉共用了，所以这里要针对不同平台作出区分
			if(e == 'baidu'){
				this.r_open_put = true // 百度里的 是否回传加粉 默认开启
			}
			else {
				this.r_open_put = false // 投放开关 默认关闭
			}
			
			
			if(e == "oppo" || e == "vivo"){
				this.r_media_account_id = undefined
			}
			this.r_jump_type = undefined // 跳转方式清空，重新选
			this.r_put_platform = e
		},
		addChangeTB(e){ // 落地页类型
			this.r_jump_content_type = e
		},
		addChangeTC(e){ // 投放开关
			this.r_open_put = e
		},
		addChangeTD(e){ // 跳转方式
			this.r_jump_type = e
		},
		
		// 选择背景色
		changeColor(e){
			// console.log(e);
			this.r_background_color = e.target.value
		},
		
		
		
		// 顶部图片上传 限制用户上传的图片格式和大小。
		beforeUpload(file){
			console.log("beforeUpload",file);
				
			// if(this.add_wx_kf_account_id){
				  const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
				  if (!isJpgOrPng) {
					this.$message.error('You can only upload JPG file!');
				  }
				  const isLt2M = file.size / 1024 / 1024 < 2;
				  if (!isLt2M) {
					this.$message.error('Image must smaller than 2MB!');
				  }
				  return isJpgOrPng && isLt2M;
			// }
			// else {
			// 	this.$message.warning('请先选择企业');
			// }
		},
		uploadChange(info){
			// console.log("图片请求",info);
			let that = this
			if (info.file.status === 'uploading') {
					this.loading = true;
					return;
			}
			if (info.file.status === 'done') {
				console.log("图片请求done",info);
				if(info.file.response){ // 图片上传成功，有内容返回
					// this.add_wx_kf_media_id = info.file.response.data.media_id
					that.r_top_image = info.file.response.data.path
					that.imageUrl = info.file.response.data.url
					that.loading = false
					// getBase64(info.file.originFileObj, imageUrl => {
					//   this.imageUrl = imageUrl;
					//   this.loading = false;
					// });
				}
				else {
					this.imageUrl = ""
					this.loading = false;
					this.$message.error(`错误：图片上传失败`);
				}
					
				
			}
			
			if (info.file.status === 'error') { // 上传失败
				
				this.imageUrl = ""
				this.loading = false;
				this.$message.error(`错误：图片上传失败`);
			
			}
		},
		// 删除选择的图片
		delTopImg(){
			this.imageUrl = ""
			this.r_top_image = ""
		},
		
		
		
		// 百度部分
		bdChangeA(e){ // 回传方式
			if(e == '1'){ // 营销通+付费阅读
				this.r_hc_token = [
					{value:""}
				]
			}
			this.r_bd_report_type = e
		},
		bdChangeB(e){
			
		},
		bdChangeC(e){ // 是否回传加粉
			this.r_open_put = e
		},
		// 新增回传token
		addHcToken(){
			let obj = {
				value: ""
			}
			this.r_hc_token.push(obj)
		},
		// 删除新增回传token
		delHcToken(e,index){
			if(this.r_hc_token.length > 1){
				this.r_hc_token.splice(index,1)
			}
			else {
				this.$message.warning('至少保留一个内容');
			}
		},
		
		// 新增侧边栏确认按钮
		addRequest(){
			let that = this
			// console.log(that.r_put_content);
			// console.log(that.r_verify_content);
			// console.log("that.r_top_image",that.r_top_image);
			
			let bbb_token = true
			if(that.r_put_platform == 'baidu'){
				that.r_hc_token.forEach(res=>{
					if(!res.value){
						bbb_token = false // 回传token为空
					}
				})
			}
			console.log("bbb_token",bbb_token);
			// 检查必填项
			if(!that.r_title){
				that.$message.warning('请填写落地页名称');
			}
			else if(!that.r_qk_platform){
				that.$message.warning('请选择渠道');
			}
			else if(!that.r_link_id){
				that.$message.warning('请选择快应用推广链接');
			}
			else if(!that.r_tt_report_type && that.r_put_platform == 'toutiao'){
				that.$message.warning('请选择头条付费回传方式');
			}
			else if(!that.r_media_account_id && (that.r_put_platform == 'oppo' || that.r_put_platform == 'vivo')){
				that.$message.warning('请选择广告账户');
			}
			else if(!that.r_put_url){
				that.$message.warning('请选择投放域名地址');
			}
			else if(!that.r_jump_content_type){
				that.$message.warning('请选择落地页类型');
			}
			else if(that.r_put_platform == 'baidu' && that.r_bd_report_type == '0' && !bbb_token){
				that.$message.warning('请填写回传Token');
			}
			else {
				that.search_button_loading = true
				console.log("else");
				// 必填内容
				let r_data = {
					// applets: [], // 这是老的逻辑，这里就不管他了
					// background_color: that.r_background_color, // 背景色
					
					title: that.r_title, // 落地页名称
					qk_platform: that.r_qk_platform, // 快应用平台
					link_id: that.r_link_id, // 快应用推广链接id
					put_platform: that.r_put_platform, // 投放平台
					
					put_domain: that.r_put_url, // 投放域名地址
					
					
					
				}
				if(that.r_put_platform != "baidu"){
					r_data.jump_type = that.r_jump_content_type // 落地页类型。跳转内容方式1：内容页，2=跳转页
				}
				
				
				// 选填内容
				if(that.r_top_image){ // 头部图片
					r_data.top_image = that.r_top_image
				}
				if(that.r_put_content){ // 投放内容
					r_data.put_content = that.r_put_content
				}
				if(that.r_verify_content){ // 审核内容
					r_data.verify_content = that.r_verify_content
				}
				// 投放开关 or 百度里的 是否回传加粉
				if(that.r_open_put){
					r_data.open_put = 1 // 打开
				}
				else {
					r_data.open_put = 0 // 关闭
				}
				
				// 投放平台
				if(that.r_put_platform == "toutiao"){ // 头条
					// 头条付费回传方式
					r_data.tt_report_type = that.r_tt_report_type
					// 巨量付费2回传
					if(that.r_is_supply_active_pay){ // 打开
						r_data.is_supply_active_pay = 1
					}
					else { // 关闭
						r_data.is_supply_active_pay = 0
					}
					// 审核公司
					r_data.company_name = that.r_company_name  // 必填项
				}
				else if(that.r_put_platform == "gdt"){ // 广点通
					
				}
				else if(that.r_put_platform == "oppo"){ // OPPO
					// OPPO-广告账户
					r_data.media_account_id = that.r_media_account_id // 必填项
					// 微信复制回传转化ID(JS跟踪)
					r_data.convert_id = that.r_convert_id || "" // 选填项
					// 审核公司
					r_data.company_name = that.r_company_name  // 必填项
				}
				else if(that.r_put_platform == "vivo"){ // VIVO
					//  VIVO广告账户 
					r_data.media_account_id = that.r_media_account_id // 必填项
					// 审核公司
					r_data.company_name = that.r_company_name  // 必填项
				}
				// 百度
				// if(that.r_put_platform == "baidu"){
				// 	r_data.bd_report_type = that.r_bd_report_type
				// 	if(that.r_bd_report_type == "0"){
				// 		let mmm = []
				// 		that.r_hc_token.forEach(res=>{
				// 			// console.log("");
				// 			mmm.push(res.value)
				// 		})
				// 		// console.log("mmm",JSON.stringify(mmm));
				// 		r_data.memo = JSON.stringify(mmm) // 备注 or 投放平台百度必填项memo回传Token
				// 	}
					
				// }
				// else {
				// 	r_data.memo = that.r_memo // 备注 or 投放平台百度必填项memo回传Token
				// }
				console.log("r_data",r_data);
				
				if(that.page_title == "新增"){
					landQaAdd(r_data).then(res=>{
						console.log("新增提交按钮",res);
						that.search_button_loading = false
						if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){
							that.$message.success('新增成功');
							setTimeout(()=>{
								that.$router.replace({name: 'landQuickApp_',params: {}})
							},1000)
						}
						else {
							if(res.data.code === 401){ // 未登录
								localStorage.removeItem("access_token");
								that.$router.replace({name: 'login',params: {type:'not_log'}})
							}
							else {
								that.$message.error(`错误：${res.data.msg}`);
							}
						}
					})
				}
				else if(that.page_title == "编辑"){
					r_data.id = that.r_edit_id
					landQaEdit(r_data).then(res=>{
						console.log("编辑提交按钮",res);
						that.search_button_loading = false
						if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){
							that.$message.success('编辑成功');
							setTimeout(()=>{
								that.$router.replace({name: 'landQuickApp_',params: {}})
							},1000)
						}
						else {
						
							
							if(res.data.code === 401){ // 未登录
								localStorage.removeItem("access_token");
								that.$router.replace({name: 'login',params: {type:'not_log'}})
							}
							else {
								that.$message.error(`错误：${res.data.msg}`);
							}
						}
					})
				}
			}
		},
		// 新增侧边栏取消按钮
		addCloseDrawer(){
			this.$router.replace({name: 'landQuickApp_',params: {}})
		},
	}
}		
</script>

<style scoped>
.form-cell-box {
	display: flex;
	align-items: center;
	margin-bottom: 20px;
}
.class-title {
	position: relative;
	font-size: 14px;
	margin-right: 25px;
	width: 190px;
	color: #333;
	text-align: right;
}

/* 必填提示 */
.required-hint {
	color: red;
	position: absolute;
	right: -8px;
}
</style>